var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 0L27 10.6667V28.2667C27 30.3285 25.3076 32 23.22 32H3.78C1.69236 32 0 30.3285 0 28.2667V3.73333C0 1.67147 1.69236 0 3.78 0H16.2Z",
    fill: "url(#paint0_linear_448_54123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 10.667H20.1709C18.0833 10.667 16.2 8.80696 16.2 6.7451V0.000325203L27 10.667Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25684 26.6666H11.7644V26.0282H9.16537V26.0148L11.7509 22.5907V22.0237H8.26136V22.6621H10.8604V22.6755L8.25684 26.113V26.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1205 21.1978C13.3962 21.1978 13.6131 20.9791 13.6131 20.7112C13.6131 20.4389 13.3962 20.2246 13.1205 20.2246C12.8492 20.2246 12.6278 20.4389 12.6278 20.7112C12.6278 20.9791 12.8492 21.1978 13.1205 21.1978ZM12.7272 26.6666H13.5137V22.0237H12.7272V26.6666Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8586 21.9434C16.176 21.9434 15.6291 22.2871 15.3398 22.8094H15.3217V22.0237H14.5759V28.2157H15.3624V25.9121H15.3805C15.6607 26.421 16.2032 26.7469 16.8766 26.7469C18.0609 26.7469 18.87 25.8005 18.87 24.3451C18.87 22.8898 18.0564 21.9434 16.8586 21.9434ZM16.7049 26.0639C15.9003 26.0639 15.3579 25.3809 15.3579 24.3451C15.3579 23.3139 15.9003 22.6264 16.7049 22.6264C17.5411 22.6264 18.0654 23.296 18.0654 24.3451C18.0654 25.3987 17.5411 26.0639 16.7049 26.0639Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_54123",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A147"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.ceaa4312e3c1b69b2ecd8088e58dfba1.svg";
export { ForwardRef as ReactComponent };